import i18n from '../i18n'

import Gym from '../assets/svgs/details/gym'
import Barbercue from '../assets/svgs/details/barbercue'
import Elevator from '../assets/svgs/details/elevator'
import GourmetBalcony from '../assets/svgs/details/gourmet-balcony'
import WashingMachine from '../assets/svgs/details/washing-machine'
import Pool from '../assets/svgs/details/pool'
import Playground from '../assets/svgs/details/playground'
import Concierge from '../assets/svgs/details/concierge'
import SportsCourt from '../assets/svgs/details/sports-court'
import PartyRoom from '../assets/svgs/details/party-room'
import Sauna from '../assets/svgs/details/sauna'

export default [
  {
    id: 1,
    detail: i18n.t('components.condominiumDetail.gym'),
    Icon: Gym,
    inputName: 'gym',
  },
  {
    id: 2,
    detail: i18n.t('components.condominiumDetail.barbecue'),
    Icon: Barbercue,
    inputName: 'barbecue',
  },
  {
    id: 3,
    detail: i18n.t('components.condominiumDetail.elevator'),
    Icon: Elevator,
    inputName: 'elevator',
  },
  {
    id: 4,
    detail: i18n.t('components.condominiumDetail.gourmetSpace'),
    Icon: GourmetBalcony,
    inputName: 'gourmet_area',
  },
  {
    id: 5,
    detail: i18n.t('components.condominiumDetail.laundry'),
    Icon: WashingMachine,
    inputName: 'building_laundry',
  },
  {
    id: 6,
    detail: i18n.t('components.condominiumDetail.pool'),
    Icon: Pool,
    inputName: 'pool',
  },
  {
    id: 7,
    detail: i18n.t('components.condominiumDetail.playground'),
    Icon: Playground,
    inputName: 'playground',
  },
  {
    id: 8,
    detail: i18n.t('components.condominiumDetail.concierge'),
    Icon: Concierge,
    inputName: 'lobby_24h',
  },
  {
    id: 9,
    detail: i18n.t('components.condominiumDetail.sportsCourt'),
    Icon: SportsCourt,
    inputName: 'sports_court',
  },
  {
    id: 10,
    detail: i18n.t('components.condominiumDetail.partyHall'),
    Icon: PartyRoom,
    inputName: 'party_hall',
  },
  {
    id: 12,
    detail: i18n.t('components.condominiumDetail.sauna'),
    Icon: Sauna,
    inputName: 'sauna',
  },
]
